import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Layer, Line, Circle, Group } from 'react-konva';
import { pointsMoved } from '../../actions/stone-bed-actions';
import { getScaledValue } from '../../actions/calculations-actions';

class StoneBed extends PureComponent {
  calculateAngle(x1, y1, x2, y2) {
    return parseInt(Math.abs((Math.atan2(Math.abs(y2 - y1), Math.abs(x2 - x1)) * 180) / Math.PI), 10);
  }

  getCircleIndex(index) {
    if (index < 0) {
      return this.circleCount - 1;
    } else {
      return index % this.circleCount;
    }
  }

  handleCircleOnDrag(index) {
    /* get circles reference */
    let pCle = this.circles[this.getCircleIndex(index - 1)];
    let cCle = this.circles[this.getCircleIndex(index)];
    let nCle = this.circles[this.getCircleIndex(index + 1)];

    /* get original  */
    let nPrevAngle = this.props.angles[index].prev;
    let nNextAngle = this.props.angles[index].next;

    let prevAxis = nPrevAngle < 50 ? 'y' : 'x';
    let nextAxis = nNextAngle < 50 ? 'y' : 'x';

    /* update position of neighbor circles */
    pCle[prevAxis](cCle[prevAxis]());
    nCle[nextAxis](cCle[nextAxis]());

    /* return all circles references */
    return {
      prev: { x: pCle.x(), y: pCle.y(), index: this.getCircleIndex(index - 1) },
      curr: { x: cCle.x(), y: cCle.y(), index: this.getCircleIndex(index) },
      next: { x: nCle.x(), y: nCle.y(), index: this.getCircleIndex(index + 1) },
    };
  }

  handleCircleOnDragEnd(index) {
    /* get the computed circles */
    let cls = this.handleCircleOnDrag(index);
    /* build the points array */
    let points = [];
    points[cls.prev.index * 2] = [cls.prev.x, cls.prev.y];
    points[cls.curr.index * 2] = [cls.curr.x, cls.curr.y];
    points[cls.next.index * 2] = [cls.next.x, cls.next.y];
    /* check if first point is pressent */
    let minPnt = Math.min(cls.prev.index, Math.min(cls.curr.index, cls.next.index));
    if (minPnt === 0) {
      points[this.props.points.length - 2] = [this.circles[0].x(), this.circles[0].y()];
    }
    /* invoke action */
    this.props.pointsMoved(points);
  }

  renderLines() {
    let lines = [];
    let points = this.props.points;

    const strokeWidth = this.props.getScaledValue(0.4);

    const sizeLiner = this.props.imperviousLiner ? [0, 0] : [6, 6];

    for (let i = 3; i < this.props.points.length; i += 2) {
      /* the coordinates and index of the line */
      let index = parseInt((i + 1) / 4, 10);
      let x1 = points[i - 3];
      let y1 = points[i - 2];
      let x2 = points[i - 1];
      let y2 = points[i];

      /* Perimeter line that surrounds the chanbers
       *  Dashed without impervious and continues with it.
       */
      let l = (
        <Line
          key={i}
          points={[x1, y1, x2, y2]}
          stroke={'black'}
          strokeWidth={strokeWidth}
          lineJoin={'round'}
          dash={sizeLiner}
          ref={(node) => {
            if (!this.lines) {
              this.lines = [];
            }
            this.lines[index] = node;
          }}
        />
      );
      lines.push(l);
    }
    return lines;
  }

  renderCircles() {
    /* this object */
    let circles = [];
    /* reinit circles to prevent bugs */
    this.circleCount = 0;

    const radius = this.props.getScaledValue(1);
    const strokeWidth = this.props.getScaledValue(0.4);

    for (let i = 0; i < this.props.points.length - 2; i += 2) {
      let index = parseInt(i / 2, 10);
      let c = (
        <Circle
          name="stoneBedPoint"
          id={index}
          key={i}
          x={this.props.points[i]}
          y={this.props.points[i + 1]}
          radius={radius}
          fill="#0C92CD"
          stroke={'black'}
          strokeWidth={strokeWidth}
          draggable={true}
          onDragMove={() => this.handleCircleOnDrag(index)}
          onDragEnd={() => this.handleCircleOnDragEnd(index)}
          ref={(node) => {
            if (!this.circles) {
              this.circles = [];
            }
            this.circles[index] = node;
          }}
        />
      );
      circles.push(c);
      this.circleCount++;
    }
    return circles;
  }

  render() {
    return (
      <Layer>
        <Group
          x={this.props.x}
          y={this.props.y}
          visible={this.props.visible}
          height={this.props.height}
          width={this.props.width}
          rotation={this.props.rotation}>
          {this.renderLines()}
          {this.renderCircles()}
        </Group>
      </Layer>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    points: state.stonebed.points,
    angles: state.stonebed.angles,
    visible: state.stonebed.visible,
    x: state.chamberbed.x,
    y: state.chamberbed.y,
    scaleX: state.chamberbed.scaleX,
    scaleY: state.chamberbed.scaleY,
    rotation: state.chamberbed.rotation,
    height: state.chamberbed.height,
    width: state.chamberbed.width,
    chamberRows: state.chamberbed.chamberRows,
    imperviousLiner: state.chamberbed.imperviousLiner,
  };
};

export default connect(
  mapStateToProps,
  {
    getScaledValue,
    pointsMoved
  }
)(StoneBed);



// WEBPACK FOOTER //
// ./src/components/Drawings/stone-bed.js